import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
  description: {
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '16px',
    color: '#2C2D3E',
    marginTop: '-10px',
    marginBottom: '20px',
  },
  iconCircle: {
    display: 'inline-block',
    width: '28px',
    height: '28px',
    marginLeft: '10px',
    verticalAlign: 'middle',
    borderRadius: '50%',
    '&:hover': {
      backgroundColor: '#CACAFC5E',
    },
  },
  defaultRoleIcon: {
    margin: '5px',
  },
  listHeader: {
    height: '50px',
    width: 'calc(100% - 10px)',
    display: 'flex',
    justifyContent: 'space-between',
  },
  tabTitle: {
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontWeight: 700,
    fontSize: '16px',
    color: '#2C2D3E',
  },
  tabSubTitle: {
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '14px',
    color: '#2C2D3E',
    marginTop: '8px',
  },
  titles: {
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontWeight: 700,
    fontSize: '14px',
    color: '#2C2D3E',
  },
  searchBar: {
    position: 'absolute',
    right: '0px',
  },
  flagContainer: {
    display: 'flex',
    width: '100%',
    height: '45px',
  },
  flagImage: {
    width: '23px',
    height: '25px',
  },
  flagLetter: {
    fontFamily: 'OpenDyslexic',
    color: 'white',
    fontSize: '10px',
    fontWeight: 700,
    fontStyle: 'italic',
    position: 'relative',
    top: '4px',
    left: '-20px',
  },
  flagLabel: {
    fontFamily: 'Roboto',
    fontSize: '14px',
    fontWeight: 600,
    color: '#2C2D3E',
    marginTop: '4px',
  },
  flagCheckbox: {
    width: '14px',
    height: '14px',
    border: 'solid 1px rgba(44, 45, 62, 0.8)',
    borderRadius: '2px',
    margin: '5px 10px 5px 0px',
    '&:focus': {
      outline: '3px solid black'
    }
  },
  paddedMasterContainer: {
    padding: '10px 25px 20px 25px',
  },
  paddedGridContainer: {
    paddingBottom: '15px'
  },
  paddedGridItem: {
    paddingBottom: '10px',
  },
  svgTextField: {
    height: '171px',
  },
  nameTextField: {
    height: '79px',
  },
  descTextField: {
    height: '148px',
  },
}));
